export function Chevron() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentcolor"
    >
      <path d="M14.9998 19C14.744 19 14.488 18.9023 14.293 18.707L8.29297 12.707C7.90234 12.3164 7.90234 11.6836 8.29297 11.293L14.293 5.29297C14.6836 4.90234 15.3164 4.90234 15.707 5.29297C16.0977 5.68359 16.0977 6.31641 15.707 6.70703L10.4139 12L15.7077 17.2937C16.0983 17.6844 16.0983 18.3172 15.7077 18.7078C15.5123 18.9031 15.2561 19 14.9998 19Z" />
    </svg>
  );
}
